import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import authVector from '../../../../../../assets/img/authVector.svg';
import palette from '@/theme/palette.ts';

import { styles } from './styles.ts';

export const TextSide = () => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{ ...styles.container, background: palette.secondary.main }}
    >
      <Box sx={styles.vector}>
        <img src={authVector} alt="authVector" />
      </Box>
      <Typography
        sx={{ ...styles.title, color: palette.primary.main }}
        dangerouslySetInnerHTML={{ __html: t('AUTH.TITLE') }}
      />
    </Stack>
  );
};
